import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

class SelectedItems extends React.Component {
  static propTypes = {
    itemLabel: PropTypes.string,
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,

    onDeselect: PropTypes.func.isRequired
  }

  handleDeselect = (event) => {
    const item = this.props.items[parseInt(event.currentTarget.dataset.index)];
    this.props.onDeselect(item);
  }

  render() {
    return (
      <div className="selected-items-section bottom-buffer-sm">
        {this.props.items.length === 0 ? this.renderEmptyItems() : this.renderItems()}
      </div>
    );
  }

  renderEmptyItems() {
    return (
      <div className="no-selected-items-message-wrapper top-buffer-sm">
        <div className="no-selected-items-message">
          No {this.props.itemLabel || 'items'} selected
        </div>
      </div>
    );
  }

  renderItems() {
    return (
      <div className="selected-items-wrapper w-100">
        <h5>Selected {this.props.itemLabel}</h5>
        <div className="selected-items-list-wrapper">
          <ul className="list-group">
            {this.props.items.map((item, i) => this.renderItem(item, i))}
          </ul>
        </div>
      </div>
    );
  }

  renderItem(item, i) {
    return (
      <li className="list-group-item row-eq-height" key={i}>
        <span className="text-truncate grow">
          {this.props.renderItem(item)}
        </span>

        <FontAwesomeIcon
          className="text-danger pull-right clickable ml-2"
          data-index={i}
          icon={faTimes}
          name="deselect"
          onClick={this.handleDeselect}
        />
      </li>
    );
  }
}

export default SelectedItems;
